import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";
import { status } from "@/utils/common";

export default {
    namespaced: true,
    state: {
        doctorPrescriptions: [],
        doctorPrescription: {
            id: null,
            medicines: [],
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.doctorPrescriptions.findIndex(i => i.id === id)
    },
    mutations: {
        SET_ITEMS: (state, data) => state.doctorPrescriptions = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_ITEM: (state, viewData) => state.doctorPrescription = viewData,
        ADD: (state, addedData) => state.doctorPrescriptions.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.doctorPrescriptions.splice(index, 1, updateData),
        DELETE: (state, index) => state.doctorPrescriptions.splice(index, 1),
        approval: (state, index) => state.doctorPrescriptions[index].status = status.active,
        cancel: (state, index) => state.doctorPrescriptions[index].status = status.cancel,

    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");
                const response = await dataService.doctorPrescriptions.getAll(paramsString);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEMS', response.data.doctorPrescriptions);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, {id,doctorId}) {
            startLoading()
            try {
             
                commit('SET_ITEM', {});
                const response = await dataService.doctorPrescriptions.getDetails(id,doctorId);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEM', response.data.doctorPrescription);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getForEdit(_,  {id,doctorId}) {
            startLoading()
            try {
                const response = await dataService.doctorPrescriptions.getForEdit(id,doctorId);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.doctorPrescription);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async add({ commit }, payload) {
            try {
                startLoading()
                const response = await dataService.doctorPrescriptions.add(payload);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);
                commit("ADD", response.data.doctorPrescription);


            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        async edit({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.doctorPrescriptions.edit(id, payload);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.doctorPrescription });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        async delete({ commit, getters }, {id,doctorId}) {
            startLoading()
            try {
                const response = await dataService.doctorPrescriptions.delete(id,doctorId);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('DELETE', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
         async cancel({ commit, getters }, {id,doctorId}) {
            startLoading()
            try {
                const response = await dataService.doctorPrescriptions.cancel(id,doctorId);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('cancel', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async approval({ commit, getters }, id) {
            try {
                startLoading()
                const response = await dataService.doctorPrescriptions.approval(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);
                const index = getters.index(id);
                commit("approval", index);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        //---------------------------------------------------------------//
        async getMedicinesStock(_, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
         
                const response = await dataService.doctorPrescriptions.getMedicinesStock(paramsString);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.stocks);

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },   
        //---------------------------------------------------------------//
        async getAppointments(_, id) {
            startLoading()
            try {
      
                const response = await dataService.doctorPrescriptions.getAppointments(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.appointments);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },  
        async getPatients(_, date) {
            startLoading()
            try {
                const response = await dataService.doctorPrescriptions.getPatients(date);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.patients);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },   async getForPrint(_, id) {
                    startLoading()
                    try {
                        const response = await dataService.doctorPrescriptions.getForPrint(id);
        
                        stopLoading()
                        if (!response.data.statusCode) {
                            showAlert(serverErrorMessage);
                            return;
                        }
                        return Promise.resolve(response.data.invoice);
        
                    } catch (error) {
                        stopLoading()
                        catchHandler(error);
                    }
                },
    },
};
